// extracted by mini-css-extract-plugin
export default {"templateBtn":"FileOptions_templateBtn__if-ZY"};